import React, { useState, useRef, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { updateUserDataAction } from "../../store/actions/actionsMain";
import { useDispatch } from "react-redux";
import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "../../config/firebaseFunctions";
import { RecaptchaVerifier } from "firebase/auth";
import { firebaseAuthFunc } from "../../config/firebaseAuth";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PhoneAuthDialog(props) {
  const [phNumberField, setphNumberField] = useState("");
  const [isButtonDisabled, setisButtonDisabled] = useState(true);
  const [otpField, setotpField] = useState("");
  const [recaptchaToken, setrecaptchaToken] = useState("");
  const [btnLoader, setbtnLoader] = useState(false);
  const [renderRecaptcha, setrenderRecaptcha] = useState(true);

  const containerRef = useRef(null);

  const router = useRouter();
  const dispatch = useDispatch();
  const { finishCallBack = () => {}} = props;
  useEffect(() => {
    if (props.dialogState) {
      setisButtonDisabled(true);
      setphNumberField("");
      setotpField("");
      setrecaptchaToken("");
      if (!renderRecaptcha) {
        setrenderRecaptcha(true);
      }
    }
  }, [props.dialogState]);

  useEffect(() => {
    if (renderRecaptcha && containerRef.current && containerRef) {
      getRecaptcha();
      setrenderRecaptcha(false);
    }
  }, [containerRef.current, renderRecaptcha]);

  const getRecaptcha = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = "";
      if(window){
        
        window.recaptchaVerifier = new RecaptchaVerifier(
          containerRef.current,
          {
            size: "normal",
            callback: (response) => {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
              setrecaptchaToken(response);
              setisButtonDisabled(false);
            },
            "expired-callback": (response) => {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
              setisButtonDisabled(true);
              toast.error("Recaptcha expired. Please try again!", {
                position: "bottom-left",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                zIndex: 2147483641,
              });
            },
          }
          , firebaseAuthFunc);
        window.recaptchaVerifier.render().then(function (widgetId) {
          window.recaptchaWidgetId = widgetId;
        });
      }
     
    }
  };

  const handleClose = () => {
    props.setdialogState(false);
  };

  const verifyPh = async () => {
    setbtnLoader(true);
    try {
      if (phNumberField.length === 0) {
        throw Error("Please enter the phone number!");
      } else if (phNumberField && !isValidPhoneNumber(phNumberField)) {
        throw Error("Please enter valid contact number");
      }
      await sendOtp();
    } catch (error) {
      setbtnLoader(false);
      toast.error(error.message, {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const sendOtp = async () => {
    //send otp
    try {
      let sendVerficationSmsAPI =      httpsCallable(firebaseFunctions,"phoneNumberVerfication")
    
      let sendVerficationSmsRes = await sendVerficationSmsAPI({
        type: "SEND-SMS",
        phoneNumber: phNumberField,
        recaptchaToken: recaptchaToken,
      });

      console.log("sendVerficationSmsRes", sendVerficationSmsRes);
      if (
        sendVerficationSmsRes &&
        sendVerficationSmsRes.data &&
        sendVerficationSmsRes.data.status &&
        sendVerficationSmsRes.data.status === "success"
      ) {
        setbtnLoader(false);

        toast.info("Code has been sent successfully", {
          position: "bottom-left",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        props.setphoneAuthDialogView(2);
      } else {
        if (
          sendVerficationSmsRes &&
          sendVerficationSmsRes.data &&
          sendVerficationSmsRes.data.status &&
          sendVerficationSmsRes.data.status === "error"
        ) {
          toast.error(sendVerficationSmsRes.data.msg, {
            position: "bottom-left",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        } else {
          toast.error("An error occured, Try again!", {
            position: "bottom-left",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        }
        setbtnLoader(false);
        getRecaptcha();
        setisButtonDisabled(true);
      }
    } catch (err) {
      setbtnLoader(false);

      toast.error("An error occured, Try again later!", {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      getRecaptcha();
      setisButtonDisabled(true);
    }
  };
  const submitOtp = async () => {
    setbtnLoader(true);

    if (otpField.length === 0) {
      toast.error("Please enter the code!", {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setbtnLoader(false);

      return null;
    }

    //verfiying the code
    try {
 
      let verifyOtpAPI =     httpsCallable(firebaseFunctions,"phoneNumberVerfication");
      let verifyOtpRes = await verifyOtpAPI({
        type: "VERIFY-OTP",
        otp: otpField,
        phoneNumber: phNumberField,
      });
      if (
        verifyOtpRes &&
        verifyOtpRes.data &&
        verifyOtpRes.data.status &&
        verifyOtpRes.data.status === "success"
      ) {
        setbtnLoader(false);

        toast.success("Phone number verified successfully", {
          position: "bottom-left",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        props.setdialogState(false);

        let modifiedObj = { ...props.userDataRedux };
        modifiedObj.phoneNumber = phNumberField;
        dispatch(updateUserDataAction(modifiedObj));
        finishCallBack(phNumberField);
      } else {
        if (
          verifyOtpRes &&
          verifyOtpRes.data &&
          verifyOtpRes.data.status &&
          verifyOtpRes.data.status === "error"
        ) {
          toast.error(verifyOtpRes.data.msg, {
            position: "bottom-left",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        } else {
          toast.error("An error occured, Try again!", {
            position: "bottom-left",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        }
        setbtnLoader(false);
      }
    } catch (err) {
      setbtnLoader(false);
      toast.error("An error occured, Try again later!", {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const View1 = (
    <div>
      <div className="ph-auth-input">
        <PhoneInput
          placeholder="Enter phone number"
          value={phNumberField}
          onChange={(value) => {
            if (value) {
              setphNumberField(value);
            }
          }}
          international={true}
        />
        <div className="recaptcha-div mt-8" ref={containerRef}></div>
        <p className="mt-8 text-md leading-relaxed text-blueGray-600">
          By tapping Verify, an SMS will be sent. Message &amp; data rates may
          apply.
        </p>
      </div>
    </div>
  );

  const View2 = (
    <div>
      <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
        Enter the 6-digit code we sent to{" "}
        <span style={{ margin: 0, fontSize: 14, display: "inline-block" }}>
          {phNumberField}
        </span>
      </label>
      <input
        onChange={(e) => {
          setotpField(e.target.value);
        }}
        type="number"
        onWheel={(e) => e.target.blur()}
        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
        value={otpField}
        placeholder="code"
      />
      <p
        className="font-normal text-sky-500 mt-4 cursor-pointer link"
        onClick={() => {
          props.setphoneAuthDialogView(1);
          // getRecaptcha();
          setisButtonDisabled(true);
          setrenderRecaptcha(true);
        }}
      >
        Change contact number
      </p>
    </div>
  );

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
    >
      <h5
        className="text-lg font-semibold"
        style={{ padding: "18px 24px 10px 24px" }}
      >
        {props.phoneAuthDialogView === 1
          ? `${props.updateNumber ? "Update" : "Add"} Your Contact Number`
          : "Verify Your Contact Number"}
      </h5>
      <div className="dialog-close-medium">
        <button
          className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
          type="button"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div className="bg-blueGray-100">
        <DialogContent>
          {props.phoneAuthDialogView === 1 ? View1 : View2}
        </DialogContent>
        <DialogActions style={{ marginTop: 15, height: 50 }}>
          {props.phoneAuthDialogView === 1 ? (
            <>
              {btnLoader ? (
                <div style={{ width: 80, textAlign: "center" }}>
                  <div className="flex justify-center	w-full">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                </div>
              ) : (
                <button
                  className={
                    isButtonDisabled
                      ? "bg-blueGray-400 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150 "
                      : "bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150 "
                  }
                  onClick={verifyPh}
                  disabled={isButtonDisabled}
                  style={{ cursor: isButtonDisabled ? "default" : "pointer" }}
                >
                  Verify
                </button>
              )}
            </>
          ) : (
            <>
              {btnLoader ? (
                <div style={{ width: 80, textAlign: "center" }}>
                  <div className="flex justify-center	w-full">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                </div>
              ) : (
                <button
                  className={
                    "bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                  }
                  onClick={submitOtp}
                >
                  Submit
                </button>
              )}
            </>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
}
